import { createThunkEffect } from "../../../utilities/ActionUtility";
import * as KaikoEffect from "./KaikoEffect";

export const REQUEST_EXCHANGES = "KaikoEffect.REQUEST_EXCHANGES";
export const REQUEST_EXCHANGES_FINISHED = "KaikoEffect.REQUEST_EXCHANGES_FINISHED";

export function getExchanges(product, params) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_EXCHANGES, KaikoEffect.getExchanges, product, params);
    };
}

export const REQUEST_BASE_CURRENCIES = "KaikoEffect.REQUEST_BASE_CURRENCIES";
export const REQUEST_BASE_CURRENCIES_FINISHED = "KaikoEffect.REQUEST_BASE_CURRENCIES_FINISHED";

export function getBaseCurrencies(product, params) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_BASE_CURRENCIES, KaikoEffect.getBaseCurrencies, product, params);
    };
}

export const REQUEST_FILES_INFO = "KaikoEffect.REQUEST_FILES_INFO";
export const REQUEST_FILES_INFO_FINISHED = "KaikoEffect.REQUEST_FILES_INFO_FINISHED";

export function getKaikoFilesInfo(product, params) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_FILES_INFO, KaikoEffect.getFilesInfo, product, params);
    };
}

export const REQUEST_PRICING_PACKAGES = "KaikoEffect.REQUEST_PRICING_PACKAGES";
export const REQUEST_PRICING_PACKAGES_FINISHED = "KaikoEffect.REQUEST_PRICING_PACKAGES_FINISHED";

export function getPricingPackages(product) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_PRICING_PACKAGES, KaikoEffect.getPricingPackages, product);
    };
}

export const REQUEST_SUBSCRIPTION_FILES_INFO = "KaikoEffect.REQUEST_SUBSCRIPTION_FILES_INFO";
export const REQUEST_SUBSCRIPTION_FILES_INFO_FINISHED = "KaikoEffect.REQUEST_SUBSCRIPTION_FILES_INFO_FINISHED";

export function getFilterableSubscriptionFilesInfo(subscriptionTypeId, params) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_SUBSCRIPTION_FILES_INFO, KaikoEffect.getFilterableSubscriptionFilesInfo, subscriptionTypeId, params);
    };
}

export const REQUEST_SUBSCRIPTION_PRICING_PACKAGES = "KaikoEffect.REQUEST_SUBSCRIPTION_PRICING_PACKAGES";
export const REQUEST_SUBSCRIPTION_PRICING_PACKAGES_FINISHED = "KaikoEffect.REQUEST_SUBSCRIPTION_PRICING_PACKAGES_FINISHED";

export function getFilterableSubscriptionPricingPackages(subscriptionTypeId) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_SUBSCRIPTION_PRICING_PACKAGES, KaikoEffect.getFilterableSubscriptionPricingPackages, subscriptionTypeId);
    };
}